<div class="box">
  <pa-counter [min]="1" [max]="99"></pa-counter>
</div>
